<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
    stroke-linejoin="round" width="22" height="22">
    <polyline points="5 18 11 12 5 6" />
    <polyline points="12 18 18 12 12 6" />
  </svg>
</template>

<script>
export default {
  name: 'LastIcon'
}
</script>
